import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-view-table",
  templateUrl: "./med-icon-view-table.component.html",
})
export class MedIconViewTableComponent extends SvgMixinComponent {}
